import { twSort } from '../../utils';

export const cardStyles = {
  base: twSort`corner-square-circle relative flex flex-col rounded-3xl bg-white bg-clip-border text-gray-700 shadow-xs dark:bg-gray-950`,
  body: twSort`px-6 py-8`,
};
